module.exports = __webpack_public_path__ + "img/prizes-hu.1c3daa97.png";